import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-default',
  templateUrl: './privacy-default.component.html',
  standalone: false,
})
export class PrivacyDefaultComponent {}
